import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import React from "react";
import WarningIcon from "./icons/WarningIcon";
import "./style.scss";
import styles from "./styleModule";

function CustomModal({
  isHaveCancel = true,
  isModalVisible,
  setIsModalVisible,
  maskClosable = false,
  title = "",
  content = "",
  needIcon = false,
  contentContainerStyle = "",
  closable = false,
  destroyOnClose = true,
  iconRender = () => {
    return <WarningIcon />;
  },
  okBtnText = " ",
  cancelBtnText = " ",
  showCloseButton = false,
  onOk = () => {
    setIsModalVisible(false);
  },
  onCancel = () => {
    setIsModalVisible(false);
  },
  onCloseModal = () => {},
  okBtnStyle = {},
  getContainer = () => document.body,
  // 有傳 extraBtnText 才會在取消與確認中間多一顆按鈕
  extraBtnText = "",
  onExtra = () => {},
}) {
  // 沒有取消、只有額外按鈕 + 確認時，兩顆各半
  const isTwoBtnWithExtra = !isHaveCancel && !!extraBtnText;
  const isOkFullWidth = !isHaveCancel && !extraBtnText;

  const handleCloseModal = () => {
    setIsModalVisible(false);
    onCloseModal();
  };

  const renderCloseButton = () => {
    if (!showCloseButton) return null;
    return (
      <div className={styles.closeButton} onClick={handleCloseModal}>
        <CloseCircleOutlined />
      </div>
    );
  };

  return (
    <Modal
      getContainer={getContainer}
      visible={isModalVisible}
      onCancel={handleCloseModal}
      footer={null}
      width={265}
      centered
      closable={closable}
      maskClosable={maskClosable}
      destroyOnClose={destroyOnClose}
      className="custom-modal"
      bodyStyle={{ borderRadius: "8px", padding: "0", maxHeight: "60vh" }}
    >
      <div className={`${styles.customModal}`}>
        <div className={`${styles.contentBox} ${contentContainerStyle}`}>
          {renderCloseButton()}
          {needIcon ? <div className={`${styles.iconBox}`}>{iconRender()}</div> : ""}
          <div className={`${styles.title}`}>{title}</div>
          <div className={`${styles.content}`}>
            {typeof content === "function" ? content() : content}
          </div>
        </div>
        <div
          className={`${styles.buttonBox} ${isOkFullWidth ? styles.fullWidth : ""} ${
            extraBtnText && isHaveCancel ? styles.threeBtn : ""
          } ${isTwoBtnWithExtra ? styles.twoBtn : ""}`}
        >
          {isHaveCancel ? (
            <Button type="text" className={`${styles.cancelBtn}`} onClick={onCancel}>
              {cancelBtnText}
            </Button>
          ) : null}
          {extraBtnText ? (
            <Button type="text" className={`${styles.extraBtn}`} onClick={onExtra}>
              {extraBtnText}
            </Button>
          ) : null}
          <Button
            type="primary"
            className={`${styles.okBtn} ${isOkFullWidth ? styles.fullWidth : ""}`}
            onClick={onOk}
            style={{
              ...okBtnStyle,
            }}
          >
            {okBtnText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default CustomModal;
